import {
	PUT_INCIDENCES,
	PUT_INCIDENCES_ERROR,
	PUT_INCIDENCES_ERROR_SHOW,
	PUT_INCIDENCES_SUCCESS,
} from './../../constants';

export const putIncidencesReducer = (state, actions) => {
	switch (actions.type) {
		case PUT_INCIDENCES:
			return {
				...state,
				loading: true,
			};
		case PUT_INCIDENCES_ERROR:
			return {
				incidences: state.incidences,
				//	collaboratorsOptions: state.collaboratorsOptions,
				loading: false,
				error: actions.payload,
				errorShow: false,
			};
		case PUT_INCIDENCES_SUCCESS:
			return {
				incidences: actions.payload,
				//collaboratorsOptions: getCollaboratorOptions(actions.payload),
				loading: false,
				error: null,
				errorShow: false,
			};
		case PUT_INCIDENCES_ERROR_SHOW:
			return {
				...state,
				errorShow: true,
			};
		default:
			return state;
	}
};
